import Layout from "../components/layout/Layout";
import Breadcrumb from "../components/layout/Breadcrumb";
import Section from "../components/layout/Section";
import SocialMedia from "../components/shared/SocialMedia";
import React from "react";
import ContactForm from "../components/shared/ContactForm";
import Head from "next/head";

const PageContact: React.FC = () => {
    return (
        <>
            <Head>
                <link rel="manifest" href="/manifest.webmanifest"/>
                <link rel="apple-touch-icon" href="/assets/imgs/app/apple-touch-icon.png"/>
                <link
                    rel="apple-touch-icon"
                    sizes="48x48"
                    href="/assets/imgs/app/apple-touch-icon-48x48.png"
                />
                <link
                    rel="apple-touch-icon"
                    sizes="57x57"
                    href="/assets/imgs/app/apple-touch-icon-57x57.png"
                />
                <link
                    rel="apple-touch-icon"
                    sizes="72x72"
                    href="/assets/imgs/app/apple-touch-icon-72x72.png"
                />
                <link
                    rel="apple-touch-icon"
                    sizes="76x76"
                    href="/assets/imgs/app/apple-touch-icon-76x76.png"
                />
                <link
                    rel="apple-touch-icon"
                    sizes="114x114"
                    href="/assets/imgs/app/apple-touch-icon-114x114.png"
                />
                <link
                    rel="apple-touch-icon"
                    sizes="120x120"
                    href="/assets/imgs/app/apple-touch-icon-120x120.png"
                />
                <link
                    rel="apple-touch-icon"
                    sizes="144x144"
                    href="/assets/imgs/app/apple-touch-icon-144x144.png"
                />
                <link
                    rel="apple-touch-icon"
                    sizes="152x152"
                    href="/assets/imgs/app/apple-touch-icon-152x152.png"
                />
                <link
                    rel="apple-touch-icon"
                    sizes="180x180"
                    href="/assets/imgs/app/apple-touch-icon-180x180.png"
                />
                <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5"/>
                <meta charSet="utf-8"/>
                <meta name="msapplication-TileColor" content="#ffffff"/>
                <meta name="msapplication-TileImage" content="/assets/imgs/ms-icon-144x144.png"/>
                <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
                <meta name="viewport" content="width=device-width, initial-scale=1"/>
                <meta name="author" content="Cohesian"/>
                <meta name="theme-color" content="#ffffff"/>
                <meta name="description"
                      content="Spreekt ons verhaal jou aan? Of je nu deel wilt uitmaken van ons team, wilt samenwerken of gewoon geïnteresseerd bent om meer te weten te komen over ons"/>
                <meta name="keywords"
                      content="Engineering, Consultancy/consulting, Entrepreneurship, Entrepreneur, Ondernemer, Ondernemerschap, Technische profielen, Ingenieur, Innovatie, Fun, Connectie, Connection, Excellence, Excellentie, Ingenieursbureau, Partner, Persoonlijke ontwikkeling, Projectsourcing, Recruitment, Rekrutering, Training, Begeleiding, advies, Vacature, Jobs, Werk, Functie, Fun factor, Koffie, Netwerken, Maakindustrie, Automotive, Farmaceutica, Cosmetica"/>
                <meta property="og:title" content="Cohesian Engineering"/>
                <meta property="og:description"
                      content="Visit our website for updates and information about Cohesian Engineering."/>
                <meta property="og:url" content="https://www.cohesian.be/"/>
                <title>Cohesian | Let’s have a coffee</title>
            </Head>
            <Layout>
                <Breadcrumb title="Contact" url="/Contact"/>
                <Section>
                    <div className="container">
                        <div className="bdr-16 box-gray-100 icon-wave">
                            <div className="row">
                                <div className="col-lg-4 mb-50 mb-lg-0">
                                    <h4 className="text-heading-3 color-gray-900 mb-10 mt-10">Cohesian</h4>
                                    <p className="text-body-text color-gray-600">
                                        Deken Habrakenstraat 7
                                        <br/>
                                        3511 Hasselt
                                    </p>
                                    <p className="text-body-text color-gray-600">
                                        <a href="tel:+32484542179" className="color-green-900"><strong>(+32)
                                            484542179</strong></a>
                                        <br/>
                                        <a href="mailto:hello@cohesian.be"
                                           className="color-green-900"><strong>hello@cohesian.be</strong></a>
                                        <br/>
                                        <span className="color-green-900"><strong>BTW:</strong> BE 0788.411.248</span>
                                    </p>
                                    <div className="mt-10">
                                        <SocialMedia/>
                                    </div>
                                    <div className="mt-10 text-body-text color-gray-600">
                                        <span className="font-bold color-green-900">Connection</span> creates excellence
                                    </div>
                                </div>
                                <div className="col-lg-8">
                                    <h2 className="text-heading-4 color-gray-900">
                                        Contacteer ons
                                    </h2>
                                    <p className='text-inter-lg my-4'>
                                        Wij staan altijd open voor vragen en opmerkingen.
                                    </p>
                                    <ContactForm/>
                                </div>
                            </div>
                        </div>
                    </div>
                </Section>
            </Layout>
        </>
    );
};

export default PageContact;
